import { Body } from "@sprout/typography";

import { Stack } from "@sprout/layout.tsx";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@components/ui/dialog";
import { Trans } from "react-i18next";
import { PrimaryButton, SecondaryButton } from "@sprout/buttons";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDeleteResume: () => void;
};

const DeleteResumeModal = ({ open, onOpenChange, onDeleteResume }: Props) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>
            <Trans i18nKey="user:resume:delete_modal:title" />
          </DialogTitle>
        </DialogHeader>
        <DialogDescription>
          <div className="support-modal__body">
            <Stack gap="8px">
              <Body>
                <Trans i18nKey="user:resume:delete_modal:description" />
              </Body>
            </Stack>
          </div>
        </DialogDescription>
        <DialogFooter>
          <DialogClose>
            <SecondaryButton>
              <Trans i18nKey="user:resume:delete_modal:cancel" />
            </SecondaryButton>
          </DialogClose>
          <DialogClose>
            <PrimaryButton onClick={onDeleteResume}>
              <Trans i18nKey="user:resume:delete_modal:confirm" />
            </PrimaryButton>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteResumeModal;
